// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Atom_Box from "../atom/Atom_Box.bs.js";
import * as Atom_Cta from "../atom/Atom_Cta.bs.js";
import * as Atom_Row from "../atom/Atom_Row.bs.js";
import * as Util_Dom from "../../util/Util_Dom.bs.js";
import * as Atom_Cell from "../atom/Atom_Cell.bs.js";
import * as Atom_Text from "../atom/Atom_Text.bs.js";
import * as UseOnBlur from "../../hook/UseOnBlur.bs.js";
import * as UseToggle from "../../hook/UseToggle.bs.js";
import * as Util_Array from "../../util/Util_Array.bs.js";
import * as Atom_Column from "../atom/Atom_Column.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Presse_Page from "../../presse/Presse_Page.bs.js";
import * as Atom_Text_Ds from "../atom/Atom_Text_Ds.bs.js";
import * as Particle_zIndex from "../particle/Particle_zIndex.bs.js";
import * as UseClickOutside from "../../hook/UseClickOutside.bs.js";
import * as Particle_Screen_Ds from "../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../particle/Particle_Spacer_Ds.bs.js";
import * as Particle_Accessibility from "../particle/Particle_Accessibility.bs.js";
import * as Particle_Background_Ds from "../particle/Particle_Background_Ds.bs.js";
import * as UseGetFocusableElement from "../../hook/UseGetFocusableElement.bs.js";
import * as Particle_Screen_Constants from "../particle/Particle_Screen_Constants.bs.js";

function toPx(value) {
  return CssJs.px(value | 0);
}

function getLeftRules(width, left, tooltipWidth) {
  var middle = tooltipWidth / 2 - width / 2;
  var leftValue = left - middle;
  return Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.left(CssJs.px(leftValue | 0))]);
}

function getTopRules(height, top, scrollY) {
  var topValue = top + scrollY + height + 20;
  return Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.top(CssJs.px(topValue | 0))]);
}

var containerZindex = Particle_zIndex.Particle_zIndex_Css.toCss({
      TAG: /* Above */1,
      _0: /* SliderArrow */13
    });

function getTooltipPositionRules(centerHoverRef, tooltipRef) {
  var buttonSize = Util_Dom.getElementSize(Util_Dom.getDomRef(centerHoverRef));
  var tooltipSize = Util_Dom.getElementSize(Util_Dom.getDomRef(tooltipRef));
  var scrollY = window.scrollY;
  var leftRules = getLeftRules(buttonSize.width, buttonSize.left, tooltipSize.width);
  var topRules = getTopRules(buttonSize.height, buttonSize.top, scrollY);
  var visibility = tooltipSize.width === 0 ? CssJs.visibility("hidden") : CssJs.visibility("visible");
  return Particle_Screen_Ds.$$Array.concat(Particle_Screen_Ds.$$Array.concat(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [
                      CssJs.position("fixed"),
                      visibility,
                      containerZindex
                    ]), leftRules), topRules);
}

var arrowRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [
      CssJs.position("absolute"),
      CssJs.unsafe("content", ""),
      CssJs.left({
            NAME: "percent",
            VAL: 50
          }),
      CssJs.marginLeft({
            NAME: "px",
            VAL: -10
          }),
      CssJs.bottom({
            NAME: "percent",
            VAL: 100
          }),
      CssJs.top({
            NAME: "px",
            VAL: -10
          }),
      CssJs.width({
            NAME: "px",
            VAL: 20
          }),
      CssJs.height({
            NAME: "px",
            VAL: 20
          }),
      CssJs.transform(CssJs.rotate(CssJs.deg(45)))
    ]);

var containerRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.borderRadius({
            NAME: "px",
            VAL: 5
          })]);

var containerBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("S", "L", undefined));

function Molecule_Select_Week_Presse$DownloadTooltip(Props) {
  var status = Props.status;
  var background = Props.background;
  var centerTooltipRef = Props.centerTooltipRef;
  var downloadItems = Props.downloadItems;
  var weekNumber = Props.weekNumber;
  var weekIndex = Props.weekIndex;
  var downloadAllLabel = Props.downloadAllLabel;
  var tooltipRef = Props.tooltipRef;
  var types = downloadItems.types;
  var pattern = downloadItems.pattern;
  var zip = Presse_Page.Guide.filterByCode(types, /* Zip */0);
  var xml = Presse_Page.Guide.filterByCode(types, /* Xml */1);
  var doc = Presse_Page.Guide.filterByCode(types, /* Doc */2);
  var match = React.useState(function () {
        return Particle_Screen_Constants.emptyRules;
      });
  var setTooltipPositionRules = match[1];
  React.useEffect((function () {
          var isMount = {
            contents: true
          };
          if (isMount.contents === true) {
            var rules = getTooltipPositionRules(centerTooltipRef, tooltipRef);
            Curry._1(setTooltipPositionRules, (function (param) {
                    return rules;
                  }));
          }
          return (function (param) {
                    isMount.contents = false;
                  });
        }), [
        centerTooltipRef,
        tooltipRef,
        status
      ]);
  var match$1 = UseGetFocusableElement.make(undefined);
  if (status) {
    return null;
  } else {
    Belt_Option.forEach(match$1[0], (function (prim) {
            prim.focus();
          }));
    return React.createElement(Atom_Column.make, {
                children: null,
                ref_: tooltipRef,
                rules: match[0]
              }, React.createElement(Atom_Column.make, {
                    alignItems: Particle_Screen_Constants.alignItemsCenter,
                    background: background,
                    blockSpace: containerBlockSpace,
                    children: null,
                    rules: containerRules
                  }, React.createElement(Atom_Text.make, {
                        children: downloadAllLabel,
                        style: Atom_Text_Ds.Presse.makeWeekSliderTooltip
                      }), React.createElement(Atom_Row.make, {
                        children: null
                      }, zip !== undefined ? React.createElement(React.Fragment, undefined, React.createElement(Atom_Cta.Link.make, {
                                  accessibility: Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, zip.ariaLabel, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                  href: Presse_Page.Guide.makeDownloadUrl(pattern, zip.code, weekNumber),
                                  label: zip.label,
                                  style: {
                                    TAG: /* Presse */16,
                                    _0: /* WeekSliderTooltip */8
                                  }
                                }), React.createElement(Atom_Text.make, {
                                  children: " | ",
                                  style: Atom_Text_Ds.Presse.makeWeekSliderTooltip
                                })) : null, doc !== undefined ? React.createElement(React.Fragment, undefined, React.createElement(Atom_Cta.Link.make, {
                                  accessibility: Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, doc.ariaLabel, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                  href: Presse_Page.Guide.makeDownloadUrl(pattern, doc.code, weekNumber),
                                  label: doc.label,
                                  style: {
                                    TAG: /* Presse */16,
                                    _0: /* WeekSliderTooltip */8
                                  }
                                }), React.createElement(Atom_Text.make, {
                                  children: " | ",
                                  style: Atom_Text_Ds.Presse.makeWeekSliderTooltip
                                })) : null, xml !== undefined ? React.createElement(React.Fragment, undefined, React.createElement(Atom_Cta.Link.make, {
                                  accessibility: Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, xml.ariaLabel, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                  href: Presse_Page.Guide.makeDownloadUrl(pattern, xml.code, weekIndex),
                                  label: xml.label,
                                  style: {
                                    TAG: /* Presse */16,
                                    _0: /* WeekSliderTooltip */8
                                  }
                                })) : null)), React.createElement(Atom_Box.make, {
                    background: background,
                    rules: arrowRules
                  }));
  }
}

var DownloadTooltip = {
  arrowRules: arrowRules,
  containerRules: containerRules,
  containerBlockSpace: containerBlockSpace,
  make: Molecule_Select_Week_Presse$DownloadTooltip
};

var display = Particle_Screen_Ds.make(undefined, undefined, undefined, "flex", undefined, "none");

var containerAutoSize = Particle_Screen_Ds.make(undefined, undefined, /* AllPlaceAvailable */0, undefined, undefined, /* AllPlaceNeeded */1);

var containerJustifyContent = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "center");

var containerAlignItems = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "center");

function Molecule_Select_Week_Presse$Slider_Item(Props) {
  var onClick = Props.onClick;
  var weekItem = Props.weekItem;
  var downloadItems = Props.downloadItems;
  var downloadAllLabel = Props.downloadAllLabel;
  var weekPrefixLabel = Props.weekPrefixLabel;
  var match = UseToggle.make(undefined, undefined, undefined, undefined);
  var closeTooltip = match.close;
  var toggleRaw = match.toggleRaw;
  var centerTooltipRef = React.useRef(null);
  var tooltipRef = React.useRef(null);
  var weekNumberLabel = weekPrefixLabel + String(weekItem.weekNumber);
  var onClickTooltip = function (param) {
    Curry._1(toggleRaw, undefined);
  };
  UseClickOutside.make(tooltipRef, closeTooltip);
  var match$1 = weekItem.status;
  var containerAccessiblity = match$1 ? undefined : Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, -1, undefined);
  UseOnBlur.make(tooltipRef, closeTooltip);
  var tmp = {
    alignItems: containerAlignItems,
    autoSize: containerAutoSize,
    children: null,
    justifyContent: containerJustifyContent,
    wrap: /* OnOneLine */1
  };
  if (containerAccessiblity !== undefined) {
    tmp.accessibility = Caml_option.valFromOption(containerAccessiblity);
  }
  var match$2 = weekItem.status;
  return React.createElement(Atom_Row.make, tmp, React.createElement(Atom_Cta.Button.Block.make, {
                  children: React.createElement(Atom_Text.make, {
                        children: weekNumberLabel,
                        style: Atom_Text_Ds.Presse.makeWeekSlider(weekItem.status)
                      }),
                  direction: Particle_Screen_Constants.flexDirectionRow,
                  onClick: onClick,
                  style: {
                    TAG: /* Presse */16,
                    _0: /* WeekSlider */6
                  }
                }), match$2 ? null : React.createElement(React.Fragment, undefined, React.createElement(Atom_Cell.make, {
                        display: display,
                        children: React.createElement(Atom_Cta.Button.make, {
                              ctaRef: centerTooltipRef,
                              onClick: onClickTooltip,
                              style: {
                                TAG: /* Presse */16,
                                _0: /* WeekSliderDownload */7
                              }
                            })
                      }), React.createElement(Atom_Cell.make, {
                        display: display,
                        children: React.createElement(Molecule_Select_Week_Presse$DownloadTooltip, {
                              status: match.state ? /* Hide */1 : /* Show */0,
                              background: Particle_Background_Ds.Presse.tooltip,
                              centerTooltipRef: centerTooltipRef,
                              downloadItems: downloadItems,
                              weekNumber: weekItem.weekNumber,
                              weekIndex: weekItem.weekIndex,
                              downloadAllLabel: downloadAllLabel,
                              tooltipRef: tooltipRef
                            })
                      })));
}

var Slider_Item = {
  display: display,
  containerAutoSize: containerAutoSize,
  containerJustifyContent: containerJustifyContent,
  containerAlignItems: containerAlignItems,
  make: Molecule_Select_Week_Presse$Slider_Item
};

var sliderBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.make("S", "XXS", "M", "M", undefined));

var justifyContent = Particle_Screen_Ds.make(undefined, undefined, "center", undefined, undefined, "start");

var width = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.pct(100));

var overFlowRules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [
      CssJs.overflowX("scroll"),
      CssJs.selector("::-webkit-scrollbar", [CssJs.display(CssJs.none)])
    ]);

var itemsWidth = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.pct(80));

function Molecule_Select_Week_Presse(Props) {
  var items = Props.items;
  var onClick = Props.onClick;
  var downloadItems = Props.downloadItems;
  var downloadAllLabel = Props.downloadAllLabel;
  var weekPrefixLabel = Props.weekPrefixLabel;
  var items$1 = Util_Array.NonEmpty.toReactElement(Util_Array.NonEmpty.map(items, (function (item) {
              return React.createElement(Molecule_Select_Week_Presse$Slider_Item, {
                          onClick: (function (param) {
                              Curry._2(onClick, item.weekNumber, item.startOfWeek);
                            }),
                          weekItem: item,
                          downloadItems: downloadItems,
                          downloadAllLabel: downloadAllLabel,
                          weekPrefixLabel: weekPrefixLabel,
                          key: String(item.weekNumber)
                        });
            })));
  return React.createElement(Atom_Row.make, {
              children: React.createElement(Atom_Row.make, {
                    blockSpace: sliderBlockSpace,
                    children: items$1,
                    justifyContent: justifyContent,
                    rules: overFlowRules,
                    width: itemsWidth,
                    wrap: /* OnOneLine */1
                  }),
              justifyContent: Particle_Screen_Constants.justifyContentCenter,
              width: width
            });
}

var make = Molecule_Select_Week_Presse;

export {
  toPx ,
  getLeftRules ,
  getTopRules ,
  containerZindex ,
  getTooltipPositionRules ,
  DownloadTooltip ,
  Slider_Item ,
  sliderBlockSpace ,
  justifyContent ,
  width ,
  overFlowRules ,
  itemsWidth ,
  make ,
}
/* containerZindex Not a pure module */
